/* This file is autogenerated, see readme.md for instructions */
import CatalogSvgIcon from '@bloomreach/banana-theme/icons/catalog.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CatalogIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CatalogSvgIcon />
    </Icon>
  );
});

CatalogIcon.displayName = 'CatalogIcon';

export default CatalogIcon;
